import { ReactNode } from 'react';
import Menu from '@mui/material/Menu';
import { navMenuPaperStyle } from "@components/ThemeRegistry/theme";

type NavMenuProps = {
	anchorEl: HTMLElement | null;
	onClose: () => void;
	children: ReactNode;
};

// Generic controlled menu shell anchored off a nav rail trigger. Anchor/open
// state and the item list both live with the caller (e.g. SideNav's account
// button today) so this can be reused for other nav sections later — pass
// MenuItems (or a mapped array/dictionary of them) as children.
export default function NavMenu({ anchorEl, onClose, children }: NavMenuProps) {
	const open = Boolean(anchorEl);

	return (
		<Menu
			anchorEl={anchorEl}
			id="nav-settings-menu"
			open={open}
			onClose={onClose}
			anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
			transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
			marginThreshold={0}
			slotProps={{
				paper: {
					elevation: 2,
					sx: {
						...navMenuPaperStyle,
						overflow: 'visible',
						'& .MuiList-root': {
							p: '0px',
							m: '0px',
						},
					},
				},
			}}
		>
			{children}
		</Menu>
	);
}
